
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.223 3.078L18.59 6.47a.66.66 0 01.35.583v4.714a9.502 9.502 0 01-5.82 8.76l-.968.418a.66.66 0 01-.526-.001l-.86-.375a9.521 9.521 0 01-5.706-8.713V7.054c0-.241.132-.464.343-.58l6.191-3.392a.66.66 0 01.629-.004zm.362 16.071a8.001 8.001 0 004.871-7.375V7.552L11.92 4.58 6.544 7.546v4.314a8.018 8.018 0 004.772 7.335l.578.254.686-.298.005-.002z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.403 6.474l6.191-3.392a.66.66 0 01.629-.004L18.59 6.47a.66.66 0 01.35.583v4.714a9.502 9.502 0 01-5.82 8.76l-.968.418a.66.66 0 01-.526-.001l-.86-.375a9.521 9.521 0 01-5.706-8.713V7.054c0-.241.132-.464.343-.58zm7.182 12.675a8.001 8.001 0 004.871-7.375V7.552L11.92 4.58 6.544 7.546v4.314a8.018 8.018 0 004.772 7.335l.578.254.686-.298.005-.002z"}})])
          )
        }
      }
    